import Prism from 'prismjs'
import 'prismjs/components/prism-json'

import render from './render'

export default {
  name: 'SourceBox',

  props: {
    value: null,

    language: {
      type: String,
      default: 'json'
    },

    rounded: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    $_value() {
      if (this.value !== undefined) {
        return Prism.highlight(JSON.stringify(this.value, null, 2), Prism.languages[this.language], this.language)
      }

      return ' '
    },

    $_class() {
      return {
        'source-box': true,
        'source-box--rounded': this.rounded,
        [`language-${this.language}`]: true
      }
    }
  },

  render
}
